import { getMessages } from '../../../../../../../store/constants';

export const CARD_PROPERTIES_SETTINGS = getMessages().getText('common.settings');
